import { FileUpload } from '../../services';

export function mapFileUploadToMedia(fileUploads: FileUpload[]) {
  return fileUploads.map((fileUpload) => {
    if (
      ["header_image", "profile"]?.includes(fileUpload.data?.type || "") ===
      false
    ) {
      fileUpload.data.type = fileUpload.data.mimetype?.startsWith("video/")
        ? "videos"
        : "images";
    }

    return {
      filesize: fileUpload.data.filesize,
      key: fileUpload.data.key,
      mimetype: fileUpload.data.mimetype,
      type: fileUpload.data.type,
      replace: fileUpload.data.replace,
    };
  });
}
